import actionCreator from '../../../shared/decorators/actionCreator';
import { REDUX_NAMESPACE } from './constants';

const ACTION_CREATORS = {
  @actionCreator(REDUX_NAMESPACE)
  attemptToAutoSave() {},

  @actionCreator(REDUX_NAMESPACE)
  autoSave() {},

  @actionCreator(REDUX_NAMESPACE)
  autoSaveRequested(requested) {
    return { requested };
  },

  @actionCreator(REDUX_NAMESPACE)
  exit() {},

  @actionCreator(REDUX_NAMESPACE)
  panCanvas(deltaX, deltaY) {
    return {
      deltaX,
      deltaY,
    };
  },

  @actionCreator(REDUX_NAMESPACE)
  panCanvasEnd(deltaX, deltaY) {
    return {
      deltaX,
      deltaY,
    };
  },

  @actionCreator(REDUX_NAMESPACE)
  panCanvasStart(deltaX, deltaY) {
    return {
      deltaX,
      deltaY,
    };
  },

  @actionCreator(REDUX_NAMESPACE)
  save() {},

  @actionCreator(REDUX_NAMESPACE)
  saveCancelled() {},

  @actionCreator(REDUX_NAMESPACE)
  saveEnd() {},

  @actionCreator(REDUX_NAMESPACE)
  saveError() {},

  @actionCreator(REDUX_NAMESPACE)
  saveRequested(requested) {
    return { requested };
  },

  @actionCreator(REDUX_NAMESPACE)
  saveStart(creativeId) {
    return { creativeId };
  },

  @actionCreator(REDUX_NAMESPACE)
  startEditingElement(
    selectedElementId,
    displayElementId,
    transformElementId,
    constraintElementId,
  ) {
    return {
      selectedElementId,
      displayElementId,
      transformElementId,
      constraintElementId,
    };
  },

  @actionCreator(REDUX_NAMESPACE)
  stopEditingElement() {},

  @actionCreator(REDUX_NAMESPACE)
  tearDown() {},
};

export default ACTION_CREATORS;
